import React, { useState } from 'react';
import ProtectedImage from '../../common/ProtectedImage/ProtectedImage';
import { MessageAttachmentWrapper } from './MessageAttachment.styles';

// Renders only if the img src is valid
const MessageAttachment = ({ src }) => {
  const [isError, setError] = useState(false);

  return (
    <MessageAttachmentWrapper classname={'message-attachment-wrapper'} hide={isError}>
      <ProtectedImage src={src} altText={'message-attachment'} onError={() => setError(true)} />
    </MessageAttachmentWrapper>
  );
};

export default MessageAttachment;
